export default "__VITE_PUBLIC_ASSET__a82709a9__"